import {
  calendarSettingsAddButton,
  calendarSettingsColumnLabel,
  calendarSettingsColumns,
} from 'shared/assets/styles';
import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import { Button } from 'shared/components/ui/button';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Section = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0;
  margin: 0;
`;

export const Title = styled.section`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0;
  margin: 0;
`;

export const Table = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const HeaderRow = styled.div`
  ${calendarSettingsColumns};
`;

export const Row = styled(HeaderRow)``;

export const ColumnLabel = styled.span`
  ${calendarSettingsColumnLabel};
`;

export const SwapIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SelectValue = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

export const SelectLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectIcon = styled.span<{ $color?: string }>`
  display: flex;

  ${({ $color, theme }) =>
    $color &&
    css`
      color: ${schemeColor($color, theme)};
    `};
`;

export const AddButton = styled(Button)`
  ${calendarSettingsAddButton};
  margin-left: -10px;
`;

export const Upsell = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const RowWarning = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  margin: 0;
  color: ${({ theme }) => theme.palette.warning.main};
`;

export const PremiumLink = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    text-decoration: underline;
  }
`;
